<template>
    <v-card :height="height" :width="width" :outlined="outlined" :elevation="elevation">
        <v-card-title v-if="showTitleOnly" class="d-flex justify-space-between">
            <span>{{ title }}</span>
            <v-btn v-if="showActionBtn" small dense color="accent" :to="btnTo">{{ btnText }}</v-btn>
        </v-card-title>
        <v-card-text>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: 'BranchCardComponent',
  props: {
    title: {
      default: 'Card Title',
      type: String
    },
    outlined: {
      default: false,
      type: Boolean
    },
    elevation: {
      type: [Number, String],
      default: null
    },
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      default: '',
      type: [Number, String]
    },
    isSuperAdmin: {
      type: Boolean,
      default: false
    },
    showActionBtn: {
      type: Boolean,
      default: false
    },
    showTitleOnly: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: ''
    },
    btnTo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    openDialog: function () {
      this.$emit('click', true)
    }
  }
}
</script>
